export enum CaseSensitivityBasic {
  sensitive = 'Case Sensitivity',
  insensitive = 'No Case Sensitivity'
}

export enum CharacterEncoding {
  ascii = 'ascii',
  base64 = 'base64',
  base64Url = 'base64url',
  binary = 'binary',
  hex = 'hex',
  latin1 = 'latin1',
  utf16 = 'utf16le',
  utf8 = 'utf8'
}

export enum CharacterEncodingBasic {
  ascii = 'ASCII',
  base64 = 'Base64',
  base64Url = 'Base64 URL',
  binary = 'Binary',
  hex = 'Hexadecimal',
  latin1 = 'Latin1',
  utf16 = 'UTF16-le',
  utf8 = 'UTF-8'
}

export enum HashAlgorithm {
  md5 = 'md5',
  sha1 = 'sha1',
  sha2224 = 'sha224',
  sha2256 = 'sha256',
  sha2384 = 'sha384',
  sha2512 = 'sha512',
  sha3224 = 'sha3-224',
  sha3256 = 'sha3-256',
  sha3384 = 'sha3-384',
  sha3512 = 'sha3-512'
}

export enum HashAlgorithmBasic {
  md5 = 'MD5',
  sha1 = 'SHA-1',
  sha2224 = 'SHA-2 224',
  sha2256 = 'SHA-2 256',
  sha2384 = 'SHA-2 384',
  sha2512 = 'SHA-2 512',
  sha3224 = 'SHA-3 224',
  sha3256 = 'SHA-3 256',
  sha3384 = 'SHA-3 384',
  sha3512 = 'SHA-3 512'
}

/**
 * Convert the string representation of a character encoding to BufferEncoding.
 * @param encoding
 */
export function normalizeCharacterEncoding<E extends `${CharacterEncoding}`, EB extends `${CharacterEncodingBasic}`>(
  encoding?: E | EB
): BufferEncoding {
  switch (encoding) {
    case CharacterEncoding.ascii:
    case CharacterEncodingBasic.ascii:
      return 'ascii';
    case CharacterEncoding.base64:
    case CharacterEncodingBasic.base64:
      return 'base64';
    case CharacterEncoding.base64Url:
    case CharacterEncodingBasic.base64Url:
      return 'base64url';
    case CharacterEncoding.binary:
    case CharacterEncodingBasic.binary:
      return 'binary';
    case CharacterEncoding.hex:
    case CharacterEncodingBasic.hex:
      return 'hex';
    case CharacterEncoding.latin1:
    case CharacterEncodingBasic.latin1:
      return 'latin1';
    case CharacterEncoding.utf16:
    case CharacterEncodingBasic.utf16:
      return 'utf16le';
    default:
    case CharacterEncoding.utf8:
    case CharacterEncodingBasic.utf8:
      return 'utf8';
  }
}

/**
 * Converts a `CaseSensitivity` reference to the appropriate regex flag ('i' for case insensitivity, empty string otherwise).
 */
export function caseSensitivityToRegexFlag<C extends `${CaseSensitivityBasic}`>(
  caseSensitivity?: CaseSensitivityBasic | C
): string {
  return caseSensitivity === CaseSensitivityBasic.insensitive ? 'i' : '';
}

/**
 * Escapes all characters in a string that have a special meaning in regular expressions.
 */
export function escapeSpecialRegexCharacters(source: string): string {
  const replaced = source.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  return replaced;
}
